module.exports = __webpack_public_path__ + "img/logo.f07cde2f.png";